<template>
    <b-form-row class="form-group" style="height: 270px">
        <b-col @click="showCalendar = false">
            <b-form-group>
                <label>{{t.from}}</label>
                <b-form-input type="text" class="form-control" v-model="currentFrom" aria-label="from"
                       :state="('from' in errors) ? false : null"
                       @click.stop="showCalendar = true"
                       @input="showCalendar = false"/>
                <b-form-invalid-feedback>{{(errors.from || []).join(' ')}}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group>
                <label>{{t.to}}</label>
                <b-form-input type="text" class="form-control" v-model="currentTo" aria-label="to"
                       :state="('to' in errors) ? false : null"
                       @click.stop="showCalendar = true"
                       @input="showCalendar = false"/>
                <b-form-invalid-feedback>{{(errors.to || []).join(' ')}}</b-form-invalid-feedback>
            </b-form-group>
        </b-col>
        <b-col style="height: 100%; overflow: auto">
            <v-calendar v-if="showCalendar" @dayclick="onDayClicked" :attributes="calendarAttributes" is-expanded/>
            <template v-else>
                <label>{{t['relative-ranges']}}</label>
                <b-list-group flush>
                    <b-list-group-item v-for="entry in presetQueries" :key="entry.name"
                                       @click="currentFrom = entry.from; currentTo = entry.to">
                        {{t.ranges[entry.name]}}
                    </b-list-group-item>
                </b-list-group>
            </template>
        </b-col>
    </b-form-row>
</template>

<script>
    import {formatISO9075, endOfDay} from "date-fns";
    import dynamicDate from '../dynamicDate'

    export default {
        name: "TimeRangeSelection",
        props: ['from', 'to', 't', 'errors'],
        data() {
            return {
                showCalendar: false,
                dateRange: {
                    start: null,
                    end: null
                },
                currentFrom: this.from,
                currentTo: this.to,

                presetQueries: [
                    {name: 'last-12', from: 'now-12h', to: 'now'},
                    {name: 'last-24', from: 'now-1D', to: 'now'},
                    {name: 'today', from: 'now:D', to: 'now:D'},
                    {name: 'today-so-far', from: 'now:D', to: 'now'},
                    {name: 'current-week', from: 'now:W', to: 'now:W'},
                    {name: 'current-week-so-far', from: 'now:W', to: 'now'},
                    {name: 'previous-week', from: 'now-1W:W', to: 'now-1W:W'},
                    {name: 'current-month', from: 'now:M', to: 'now:M'},
                    {name: 'current-month-so-far', from: 'now:M', to: 'now'},
                    {name: 'previous-month', from: 'now-1M:M', to: 'now-1M:M'}

                ]
            };
        },
        computed: {
            calendarAttributes() {
                let dates
                if (this.dateRange.start && !this.dateRange.end) dates = [this.dateRange.start]
                else if (this.dateRange.start && this.dateRange.end) dates = [this.dateRange]
                else dates = []

                return [{
                    highlight: {},
                    contentStyle: {
                        color: 'white',
                    },
                    dates
                }]
            },
        },
        watch: {
            dateRange: {
                deep: true,
                handler() {
                    if (this.dateRange.start && this.dateRange.end)  {
                        this.currentFrom = formatISO9075(this.dateRange.start)
                        this.currentTo = formatISO9075(endOfDay(this.dateRange.end))
                    }
                }
            },
            from() {
                this.currentFrom = this.from
            },
            to() {
                this.currentTo = this.to
            },
            currentFrom() {
                this.emitChange()
            },
            currentTo() {
                this.emitChange()
            }
        },
        methods: {
            emitChange() {
                this.$emit('change', {
                    from: dynamicDate(this.currentFrom, 'start'),
                    to: dynamicDate(this.currentTo, 'end')
                })
            },
            onDayClicked(e) {
                if (this.dateRange.start && this.dateRange.end) {
                    this.dateRange.start = null
                    this.dateRange.end = null
                }
                if (!this.dateRange.start) this.dateRange.start = e.date
                else if (!this.dateRange.end) this.dateRange.end = e.date
            },
        }
    }
</script>

<style scoped>

</style>
